// Store markers outside of the function scope,
// not to recreate them on every call
const entities = {
  amp: '&',
  apos: "'",
  lt: '<',
  gt: '>',
  quot: '"',
  nbsp: '\xa0'
};
const entityPattern = /&([a-z]+);/gi;
export default function decodeHTMLEntities(text) {
  if (text === void 0) {
    text = '';
  }
  return text.replace(entityPattern, (match, entity) => {
    entity = entity.toLowerCase();
    if (entities[entity]) {
      return entities[entity];
    }
    // return original string if there is no matching entity (no replace)
    return match;
  });
}